module.exports = __webpack_public_path__ + "img/art_2_2.300a8f02.jpg";